import { type PayloadAction, createSlice } from '@reduxjs/toolkit'

import { useDispatchedActions } from '@web/shared/hooks/use-dispatched-actions.hook'

type TAssessmentModal = {
  mode: 'view' | 'edit'
  assessmentId: string
}

export interface IIntegralMachineConclusionState {
  assessmentListOpen: boolean
  assessmentModal: TAssessmentModal | null
  assessmentHistoryId: string | null
  maintenanceHistoryOpen: boolean
}

const initialState: IIntegralMachineConclusionState = {
  assessmentListOpen: false,
  assessmentModal: null,
  assessmentHistoryId: null,
  maintenanceHistoryOpen: false
}

export const integralMachineConclusionSlice = createSlice({
  name: 'integralMachineConclusion',
  initialState,
  reducers: {
    openAssessmentList(state) {
      state.assessmentListOpen = true
    },
    closeAssessmentList(state) {
      state.assessmentListOpen = false
      state.assessmentModal = null
      state.assessmentHistoryId = null
    },
    openAssessmentDetails(state, { payload }: PayloadAction<string>) {
      state.assessmentModal = { mode: 'view', assessmentId: payload }
    },
    openAssessmentEdit(state, { payload }: PayloadAction<string>) {
      state.assessmentModal = { mode: 'edit', assessmentId: payload }
    },
    closeAssessmentModal(state) {
      state.assessmentModal = null
    },
    openAssessmentHistory(state, { payload }: PayloadAction<string>) {
      state.assessmentHistoryId = payload
    },
    closeAssessmentHistory(state) {
      state.assessmentHistoryId = null
    },
    openMaintenanceHistory(state) {
      state.maintenanceHistoryOpen = true
    },
    closeMaintenanceHistory(state) {
      state.maintenanceHistoryOpen = false
    },
    resetIntegralMachineConclusionState() {
      return initialState
    }
  }
})

export const integralMachineConclusionReducer =
  integralMachineConclusionSlice.reducer

export const useIntegralMachineConclusionActions = () =>
  useDispatchedActions(integralMachineConclusionSlice.actions)
